import request from '@/utils/request';

const baseURLAdmin = process.env.VUE_APP_ADMIN; // /admin

/**
 * 供应商查询分页
 */
export const supplierMainPage = (data) => {
  return request({
    method: 'POST',
    url: '/provider/page',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 创建供货商信息
 */
export const addSupplierMain = (data) => {
  return request({
    method: 'POST',
    url: '/provider/add',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 根据id查询供货商信息
 */
export const getSupplierMainInfo = (ids, isLoading = true) => {
  // return request.get(`/provider/get/${data}`);
  return request({
    url: `/provider/get/${ids}`,
    method: 'get',
    isLoading // 是否显示加载中参数
  });
};

/**
 * 查询供应商的所有供应商主体
 */
export const getSupplierBody = (data) => {
  return request.post(`/provider/getAllProviderBody`);
};

/**
 * 根据id更改供应商信息
 */
export const UpdateSupplierMain = (data) => {
  return request({
    url: '/provider/update',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
// 校验供应商简称是否重复
export const apiSelectProviderName = (data) => {
  return request({
    method: 'POST',
    url: '/provider/selectProviderName',
    data,
    baseURL: baseURLAdmin
  });
};
// 校验业务主体是否重复
export const apiSelectProviderBody = (data) => {
  return request({
    method: 'POST',
    url: '/provider/selectProviderBody',
    data,
    baseURL: baseURLAdmin
  });
};

/**
 * 根据id查询供货商信息
 */
export const getBankList = () => {
  return request({
    method: 'get',
    url: '/new-dict/data/options?dictType=bank',
    baseURL: baseURLAdmin
  });
};

/**
 * @description: 供应商操作日志分页
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export const providerOperationLogPage = (data) => {
  return request({
    url: '/providerOperationLog/page',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
/**
 * 供应商查询所有
 */
export const supplierMainList = (data) => {
  return request({
    url: '/provider/list',
    method: 'get',
    data,
    baseURL: baseURLAdmin
  });
};
// 供货商状态
export const enableDisableButton = (data) => {
  return request({
    url: '/provider/enableDisableButton',
    method: 'post',
    data,
    baseURL: baseURLAdmin
  });
};
/**
 * 下载模板  ==>  供应商邮编
 */
export const providerGetModule = () => {
  return request({
    method: 'get',
    url: '/provider/download/module',
    responseType: 'blob',
    baseURL: baseURLAdmin
  });
};
/**
 * 导入数据  ==>  供应商邮编
 */
export const providerImportData = (data) => {
  return request({
    method: 'POST',
    data,
    baseURL: baseURLAdmin,
    url: '/provider/importData',
    headers: {
      'Content-Type': 'multipart/form-data' // 设置 Content-Type
    }
  });
};
